module.exports = {
    expired_1: "लिंक समाप्त",
    limit_time: "सीमित समय का ऑफर ",
    participate: "अपना विशेष इनाम प्राप्त करने के लिए अब समीक्षा इवेंट में भाग लें!",
    exclusive: "विशेष",
    reward: "इनाम",
    token: "टोकन",
    vip: "दिन VIP",
    after_completing: "समीक्षा और स्क्रीनशॉट सत्यापन पूरा करने के बाद, आप प्राप्त करेंगे",
    step_1: "<strong style='color: #000000'>नीचे दिए गए बटन पर क्लिक करें</strong> ऐप स्टोर पर जाने के लिए और <strong style='color: #000000'>5-स्टार समीक्षा छोड़ें.</strong>",
    step_2: "समीक्षा पूरा करने के बाद, कृपया अपनी समीक्षा सामग्री का <strong style='color: #000000'>स्क्रीनशॉट लें</strong>।",
    step_3: "<strong style='color: #000000'>स्क्रीनशॉट अपलोड करें</strong> नीचे और अपना इन-ऐप आईडी सबमिट करें अपना इनाम प्राप्त करने के लिए।",
    click_to: "1. पर जाने के लिए क्लिक करें ",
    upload: "2. समीक्षा स्क्रीनशॉट अपलोड करें",
    app_store: "ऐप स्टोर",
    google_play: "Google Play",
    go_to: "पर जाएं ",
    example: "स्क्रीनशॉट उदाहरण",
    upload_screenshot: "स्क्रीनशॉट अपलोड करें",
    claim: "इनाम प्राप्त करें",
    verification_inprogress: "आपके अपलोड के लिए धन्यवाद। आपका स्क्रीनशॉट यथाशीघ्र समीक्षा के लिए भेजा गया है। कृपया धैर्य रखें।",
    verification_success: "बधाई हो! <br/><br/> आपने अपना इनाम सफलतापूर्वक प्राप्त कर लिया है। इनाम आपके खाते में <strong>24 घंटे के भीतर</strong> जमा कर दिया जाएगा। कृपया देखते रहें। <br/><br/> यदि आपके कोई प्रश्न हैं, तो कृपया ग्राहक सहायता से संपर्क करने में संकोच न करें।",
    verification_failed: "समीक्षा के स्क्रीनशॉट को निम्नलिखित शर्तों को पूरा करना होगा: <br/><br/> <div style='margin-left: 6px'> 1.रेटिंग 5 स्टार होनी चाहिए और सामग्री सकारात्मक होनी चाहिए। <br/><br/> 2.समीक्षा <strong> Apple App Store या Google Play Store </strong> पर की जानी चाहिए। <br/><br/> 3.स्क्रीनशॉट में समीक्षा सामग्री पूरी तरह से प्रदर्शित होनी चाहिए, जिसमें <strong> अवतार, उपयोगकर्ता नाम और समीक्षा पाठ शामिल है। <strong></div>",
    reupload: "पुनः अपलोड करें",
}